import { gql } from '@apollo/client';

export const DELETE_PRODUCT_GROUP_MUTATION = gql`
  mutation DeleteProductGroup($id: Int!) {
    md {
      deleteProductGroup(id: $id) {
        success
        message {
          code
          message
        }
        content
      }
    }
  }
`;
